import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./useAuth";

export default function ProtectedRoute({ children }) {
  const { userId } = useAuth();
  if (!userId) return <Navigate to="/partner-join" replace />;
  return children;
}
